import { lazy } from 'react'

export { AUTH_PATHS, AUTH_SCREENS } from './constants'
export { default as AuthModal } from './AuthModal'

// Route element for /connect and /sign-up (standalone white page).
export const AuthPage = lazy(() => import('./AuthPage'))
